import { render, staticRenderFns } from "./SortingDropdown.vue?vue&type=template&id=f81db53e&scoped=true"
import script from "./SortingDropdown.vue?vue&type=script&lang=js"
export * from "./SortingDropdown.vue?vue&type=script&lang=js"
import style0 from "./SortingDropdown.vue?vue&type=style&index=0&id=f81db53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81db53e",
  null
  
)

export default component.exports